"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.function.name");




















































































var _user = require("@/utils/user");


var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      droplist: [], independentArr: [{ name: '是', value: 'Y' }, { name: '否', value: 'N' }], searchData: { id: '', name: '', enabled: '', code: '', page: 1, // 当前页码
        rows: 10 // 页码条数
      }, tableColumns: [{ prop: 'name', label: '品牌名称', isShow: true }, { prop: 'code', label: '品牌编码', isShow: true }, { prop: 'operatorName', label: '维护人', isShow: true }, { prop: 'independentUserSys', label: '是否独立用户体系', formatter: _formatter.independentUserSysFormatter, isShow: true }, { prop: 'enabled', label: '状态', formatter: _formatter.enabledFormatter, isShow: true }, { prop: 'createTime', label: '创建时间', sortable: true, formatter: _formatter.dateFormatter, isShow: true }, { prop: 'updateTime', label: '更新时间', sortable: true, formatter: _formatter.dateFormatter, isShow: true }], pageData: { page: 1, rows: 10, total: 0, pages: 1 }, newadd: false, title: '新增', addData: { id: '', name: '', enabled: 0, code: '', independentUserSys: '' }, defaultData: { id: '', enabled: 0, name: '',
        code: '',
        independentUserSys: '' },

      rules: {
        code: [{
          required: true,
          message: '请输入品牌编码',
          trigger: 'blur' }],

        name: [{
          required: true,
          message: '请输入品牌名称',
          trigger: 'blur' }],

        independentUserSys: [{
          required: true,
          message: '请选择是否独立用户体系',
          trigger: 'change' }] } };



  },
  mounted: function mounted() {
    var self = this;
    self.init();
    //			self.getdrop()
  },
  methods: {
    checkPermission: _user.checkPermission,
    init: function init() {
      var self = this;
      self.getData('/api/faBrandInfo', self.searchData, function (res) {
        self.tableData = res.list;
        self.pageData.page = res.pageNum;
        self.pageData.total = res.total;
      });
    },
    resetFun: function resetFun() {// 重置
      this.searchData.name = '';
      this.searchData.enabled = '';
      this.searchData.code = '';
      this.searchData.page = 1;
      this.init();
    },
    searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;
      this.init();
    },

    handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    delMenu: function delMenu(item) {
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/faBrandInfo/' + item.id, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    addFun: function addFun() {// 新增
      this.title = '新增';
      this.addData = JSON.parse(JSON.stringify(this.defaultData));
      this.newadd = true;
    },
    enableFun: function enableFun(item, type) {
      var self = this;
      if (item.enable === type) {
        this.$message({
          message: '当前状态相同，无需修改!',
          type: 'warning' });

        return;
      }
      self.$confirm('确定审核该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.postData('/api/faInstorage/' + item.id + '/' + 'audit', {
          enable: type },
        function (res) {
          self.$message({
            message: '修改成功!',
            type: 'success' });

          item.enable = type;
          self.init();
        });
      }).catch(function () {});
    },
    closeRefund: function closeRefund(done) {// 重置新增列表
      this.$refs.addForm.resetFields();
      // this.$refs['addForm'].resetFields()
      done();
    },
    onSubmit: function onSubmit() {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/faBrandInfo', self.addData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    updateMenu: function updateMenu(item) {
      if (item.enabled === 0) {
        this.$message({
          message: '已经启用，不能再修改!',
          type: 'warning' });

        return;
      }
      this.title = '修改';
      var self = this;
      console.log(item);
      this.addData = {
        id: item.id,
        enabled: item.enabled,
        name: item.name,
        code: item.code,
        independentUserSys: item.independentUserSys + '' };

      self.newadd = true;
    },
    onUpdate: function onUpdate(item) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/faBrandInfo/' + self.addData.id, self.addData, function (res) {
            self.$message({
              message: '修改成功!',
              type: 'success' });

            // self.onCencal()
            self.searchData.page = 1;
            self.init();
            self.onCencal();
          });
        } else {
          return false;
        }
      });
    },
    onCencal: function onCencal() {
      this.newadd = false;
      this.$refs['addForm'].resetFields();
    },
    changeappTypeFun: function changeappTypeFun(val) {
      var self = this;
      if (val === '0') {
        self.addData.enabled = '0';
      }
      if (val === '1') {
        self.addData.enabled = '1';
      }
    },
    auditFun: function auditFun(item, type) {
      var self = this;
      if (item.enabled === type) {
        this.$message({
          message: '当前状态相同，无需修改!',
          type: 'warning' });

        return;
      }
      self.$confirm('确定修改该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.postData('/api/faBrandInfo/' + item.id + '/enabled/' + type, {}, function (res) {
          self.$message({
            message: '修改成功!',
            type: 'success' });

          item.enabled = type;
          self.init();
        });
      }).catch(function () {});
    } } };exports.default = _default;